import { Language } from '../constants/ui-utils.constant';
import { LanguageLocal } from '../enum/ui-utils.enum';
import { FilterType } from '../enum/webinar-course.enum';

export interface ListFilter {
    skip?: number;
    take?: number;
    paging?: boolean;
    startDate?: string;
    endDate?: string;
    searchBy?: string;
    searchString?: string;
    // Clips list only: push completed clips to the back of the result so
    // the homepage carousel surfaces unfinished content first. Backend
    // ignores it for endpoints that don't sort by playback state.
    deprioritizeWatched?: boolean;
}

export class ListFilterModel {
    skip: number;
    take: number;
    paging: boolean;
    startDate: string;
    endDate: string;
    searchBy: string;
    searchString: string;

    constructor(private model: ListFilter) {
        this.skip = model.skip || 0;
        this.take = model.take || 9;
        this.paging = model.paging || true;
        this.startDate = model.startDate || "";
        this.endDate = model.endDate || "";
        this.searchBy = model.searchBy || "";
        this.searchString = model.searchString || "";
    }
}

export interface ProgramFilterInterface {
    programTypes: ProgramTypesListInterface[];
    programTopics: ProgramTopicsListInterface[];
}

export interface ProgramTypesListInterface {
    id: number;
    value: string;
    categories: string[];
    sub: ProgramTypesListInterface[] | null;
}

export interface ProgramTopicsListInterface {
    id: string;
    name: string;
    isFilterByYear: boolean;
    sub: ProgramTopicsListInterface[] | null;
    translations: TopicTranslations[];
}
export interface TopicTranslations {
    language: Language;
    description: string;
}

export interface ProgramTopics<T> {
    programTopics: T;
}

export interface RecursiveMatSelectInterface {
    id: string;
    name: string;
    expanded: boolean;
    selected: boolean;
    disabled?: boolean;
    children: RecursiveMatSelectInterface[];
    filterType?: FilterType | null;
}

export interface RecursiveSelectedInterface {
    id: string;
    name: string;
    parentId?: string[];
    filterType?: FilterType | null;
    childId?: string[];
}

export class RecursiveMatSelectModel {
    id: string;
    name: string;
    expanded = false;
    selected = false;
    disabled = false;
    children: RecursiveMatSelectModel[] = [];
    filterType: FilterType | null;
    isFilterByYear: boolean;

    constructor(
        private model: ProgramTopicsListInterface,
        private currentLang: string,
        private filterEnum?: FilterType,
    ) {
        this.id = model.id;
        this.name = model.name;
        this.filterType = filterEnum ? filterEnum : FilterType.Topic;
        this.isFilterByYear = model.isFilterByYear;

        if (model.sub) {
            this.children = model.sub.map((child) => new RecursiveMatSelectModel(child, currentLang));
        }

        if (currentLang === LanguageLocal.LanguageCN) {
            this.name = model.translations?.find((t) => t.language === Language.CH)?.description || model.name;
        }
    }
}
